// @flow
import * as React from 'react'
import { AppContext, type AppContextValue } from './App'

type Props = {
  children: React.Node,
}

export default class UnlessAuthenticated extends React.Component<Props> {
  static contextType = AppContext
  context: AppContextValue

  render = () => {
    return this.context.user ? null : this.props.children
  }
}
